import { Stat } from './Stat';
import { AccountFactEntryType } from "./AccountFactEntryType";

const DEFAULT_COUNT = 1;

export async function sendDeleteFunnelOpening() {
    return Stat.sendEvent(AccountFactEntryType.CLIENT_ACCOUNT_DELETE_FUNNEL_OPENING_FORM_BUTTON_CLICK);
}

export async function sendDeleteFunnelConfirmButton(deleteButton: boolean) {
    return Stat.sendEvent(
        AccountFactEntryType.CLIENT_ACCOUNT_DELETE_FUNNEL_CONFIRMATION_WINDOW_BUTTON_CLICK,
        DEFAULT_COUNT,
        [(Number(deleteButton))]
    );
}

export enum AuthPoint {
    EMAIL_OTP,
    EMAIL_PASSWORD,
    FB,
    GOOGLE,
    APPLE_ID,
}

const AuthPointToIprops = {
    [AuthPoint.EMAIL_OTP]: [2,0,0],
    [AuthPoint.EMAIL_PASSWORD]: [2,0,1],
    [AuthPoint.FB]: [2, 1],
    [AuthPoint.GOOGLE]: [2, 2],
    [AuthPoint.APPLE_ID]: [2, 5],
}

export async function sendAccountAuth(authPoint: AuthPoint) {
    return Stat.sendEvent(
        AccountFactEntryType.FACT_AUTH_ACCOUNT_AUTH,
        DEFAULT_COUNT,
        AuthPointToIprops[authPoint]
    );
}

